import { render, staticRenderFns } from "./EditBonusRateComponent.vue?vue&type=template&id=072b95fe"
import script from "./EditBonusRateComponent.vue?vue&type=script&lang=js"
export * from "./EditBonusRateComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports